export default "__VITE_ASSET__bedaa016__"